import DimensionSearchList from './DimensionSearchList';

export default DimensionSearchList;
